// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__2JOv8","spin":"Spinner_spin__GH7Hr"};